<!-- Right navbar links -->
<ul class="navbar-nav">
    <li class="nav-item">
        <button (click)="CerrarSesion()" type="button" class="btn btn-light"> <i class="fas fa-sign-out-alt"></i> Cerrar Sesión</button>
        <!-- <a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#" role="button">
            <i class="fas fa-sign-out-alt"></i> Cerrar Sesión
        </a> -->
    </li>
</ul>
